/* eslint-disable factorial/no-raw-html */
import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface CardProps {
  title: string
  description: string
  img: string
  onClick?: () => void
}

export const Card = ({ title, description, img, onClick }: CardProps) => {
  const [hover, setHover] = useState(false)

  return (
    <Box
      borderRadius={{ all: 'abs016' }}
      border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
      gap="s12"
      paddingX="s8"
      paddingTop="s8"
      paddingBottom="s16"
      {...(onClick && {
        cursor: 'pointer',
        onClick: onClick,
        onMouseEnter: () => setHover(true),
        onMouseLeave: () => setHover(false),
        ...(hover && { style: { boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)' } }),
      })}
    >
      <img src={img} alt={title} style={{ maxWidth: '100%', height: 'auto' }} />

      <Box gap="s8" paddingX="s4">
        <Text.Normal weight="medium" color="grey1000">
          {title}
        </Text.Normal>
        <Text.Normal size="200">{description}</Text.Normal>
      </Box>
    </Box>
  )
}
